import {Type} from 'constants/UIComponentEnum';
import {
  AutoA1OffsetCalibrationState,
  AutoCalibrationControllerState,
  CommonButtonLabel,
  FastRobotErrorcode,
  ViewMode,
} from 'constants/dataEnum';
import {parseMessage} from 'lib/stringHelper';
import {changeView, hideLoading, showLoading} from 'stores/actions/appStateAction';
import {showModalSimplified} from 'stores/business/commonModalBusiness';
import {getAutoA1OffsetCalibrationStatus, safeAutoA1OffsetCalibration} from 'stores/business/instrumentBusiness';

import {TipsPickupSelectors} from 'stores/selectors/headSelectors';
import {setErrorCodeNumber} from 'stores/business/commonBusiness';
import {showLoadCellErrorModal} from 'stores/business/loadCellErrorBusiness';

import {batch} from 'react-redux';
import {
  setTipsPickupIsRecentlyCalibrated,
  setTipsPickupLastCalibratedDate,
  setTipsPickupPosition,
} from 'stores/actions/headStateAction';
import {setAutoA1OffsetCalibrationProgress} from 'stores/actions/wizardStateAction';
import {getCurrentProgressAutoA1OffsetCalibration} from 'api/setupwizard';

import {tipsPickupCalibrationErrorHandler} from './tipsPickupCalibrationErrorHandlerBusiness';
import A1OffsetCalibrationLoading from './A1OffsetCalibrationLoading';

export const showA1OffsetCalibrationConfirmationModal = (onConfirm) => (dispatch) => {
  const title = parseMessage('tipsPickupCalibration.modal.startWarning.title');
  const body = parseMessage('tipsPickupCalibration.modal.startWarning.text');
  const buttons = [
    {onClick: onConfirm, label: parseMessage(CommonButtonLabel.CONFIRM)},
    {label: parseMessage(CommonButtonLabel.CANCEL), type: Type.BASIC},
  ];

  dispatch(showModalSimplified(title, body, buttons));
};

export const showA1OffsetCalibrationLoading = () => (dispatch) => {
  dispatch(showLoading(<A1OffsetCalibrationLoading />));
};

export const runAutoA1OffsetCalibrationAndShowLoading = () => async (dispatch) => {
  dispatch(showA1OffsetCalibrationLoading());
  const errorCode = await dispatch(safeAutoA1OffsetCalibration());

  if (errorCode !== FastRobotErrorcode.NoError) {
    const successCallback = () => dispatch(runAutoA1OffsetCalibrationAndShowLoading());
    dispatch(hideLoading());

    if (
      errorCode === FastRobotErrorcode.LOAD_CELL_VALUE_NO_CHANGE ||
      errorCode === FastRobotErrorcode.LOAD_CELL_DRIVER_FAULT ||
      errorCode === FastRobotErrorcode.LOAD_CELL_READ_TIMEOUT
    ) {
      dispatch(setErrorCodeNumber(errorCode));
      dispatch(showLoadCellErrorModal(() => dispatch(changeView(ViewMode.EXPLORER)), errorCode, successCallback));
      return;
    }
    dispatch(tipsPickupCalibrationErrorHandler(errorCode, successCallback));
  }
};

export const fetchAndSetTipsPickupCalibrationData = () => async (dispatch) => {
  dispatch(showLoading());

  const status = await dispatch(getAutoA1OffsetCalibrationStatus());
  const {a1Offset, a1OffsetCalibrateDateTime} = status || {};
  console.log(a1Offset);

  batch(() => {
    dispatch(setTipsPickupPosition(a1Offset || {x: '-', y: '-', z: '-'}));
    dispatch(
      setTipsPickupLastCalibratedDate(
        a1OffsetCalibrateDateTime ? new Date(a1OffsetCalibrateDateTime).toLocaleDateString() : null,
      ),
    );
    dispatch(setTipsPickupIsRecentlyCalibrated(true));
    dispatch(fetchAndCheckAutoA1OffsetCalibrationProgress());
  });
};

export const isTipsPickupStateUninitialized = () => (dispatch, getState) => {
  const position = TipsPickupSelectors.getPosition(getState());
  return Object.values(position).find((pos) => pos === '-');
};

export const isTipsPickupCalibrationExecutor = () => async (dispatch, getState) => {
  const {sessionState} = getState();
  const {username} = sessionState.user;

  const {usernameExecutor} = await dispatch(getAutoA1OffsetCalibrationStatus());
  return usernameExecutor === username;
};

export const checkOngoingTipsPickupCalibration = () => async (dispatch) => {
  const {autoCalibrationControllerState} = await dispatch(getAutoA1OffsetCalibrationStatus());

  if (autoCalibrationControllerState === AutoCalibrationControllerState.RUNNING) {
    dispatch(showA1OffsetCalibrationLoading());
  }
};

const fetchAndCheckAutoA1OffsetCalibrationProgress = () => async (dispatch) => {
  const response = await getCurrentProgressAutoA1OffsetCalibration();
  const {progressState, progressPercentage} = response || {};
  if (!progressState || progressState === AutoA1OffsetCalibrationState.NONE) {
    dispatch(hideLoading());
  } else {
    dispatch(setAutoA1OffsetCalibrationProgress(progressPercentage));
    dispatch(showA1OffsetCalibrationLoading());
  }
};
